import type React from 'react';

import { InfoCircleIcon } from '@vlabs/icons';
import type { PlaceholderImageType, SampleSize } from '@vlabs/uikit';
import { Tooltip } from '@vlabs/uikit';
import { BaseSamplePlaceholder } from '@vlabs/uikit/components/sample/base-sample/BaseSamplePlaceholder';
import { useTranslation } from 'react-i18next';

interface ImageSamplePlaceholderProps {
  imageType?: PlaceholderImageType;
  size?: SampleSize;
}

function ImageSamplePlaceholder({
  imageType = 'face',
  size = 'large',
}: ImageSamplePlaceholderProps): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <BaseSamplePlaceholder
      placeholderImageType={imageType}
      placeholderType="image"
      showTextOnPlaceholder={false}
      size={size}
      tooltip={(
        <Tooltip tooltipContent={t('no_image')}>
          <InfoCircleIcon />
        </Tooltip>
      )}
    />
  );
}

export { ImageSamplePlaceholder };
